module.exports = __webpack_public_path__ + "img/s1_v3.20721a0b.png";